module.exports = __webpack_public_path__ + "static/media/msl_tactical_comparison.1f45ad9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_tactical_comparison.jpg
// module id = 86
// module chunks = 0